import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const expectedRoles: string[] = route.data['roles'] || [];
    const current = this.authService.currentUserValue;

    if (!current) {
      // not logged in
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const roles: string[] = (current.user?.roles) || (current.roles) || [];
    const hasRole = expectedRoles.length === 0 || expectedRoles.some(r => roles.includes(r));

    if (!hasRole) {
      // unauthorized
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }

}
